import PositionsMaintainerDarkstore from '../src/components/sections/PositionsMaintainerDarkstore';

export default PositionsMaintainerDarkstore;
